import { FC, useCallback, useRef, useState } from 'react';
import { SwiperTabs } from '~/components/swiper-tab';
import { useAtomValue } from 'jotai';
import { $CurrentHashtagInfoAsAvailable } from '@hashtag/shared/current-hashtag-info';
import { HashtagPostFragment } from '@hashtag/body/hashtag-post/hashtag-post-fragment';

import './style.scss';

export const HashtagPost: FC = () => {
  const hashtag = useAtomValue($CurrentHashtagInfoAsAvailable);

  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = useCallback((_: unknown, index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <div className="hashtag-post">
      <SwiperTabs
        onChange={handleChange}
        swipeable={true}
        className="hashtag-post-tabs"
        tabs={hashtag.streamTabList.map((item) => ({
          key: `${item.category}`,
          value: item.tabName,
        }))}
      >
        <HashtagPostFragment type="popular" active={tabIndex === 0} />
        <HashtagPostFragment type="recent" active={tabIndex === 1} />
      </SwiperTabs>
    </div>
  );
};
